import { Auth } from '@leverege/api-redux';
import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.screens.main.LogOut');
export default {
  id: 'user.desktop.LogOut',
  matches: {
    use: 'userBar',
    client: 'Main'
    // add persona here
  },
  layout: {
    group: ['user'],
    groupIcons: [() => {
      return Config.get('Main', 'userIcon', 'https://molten-ui-assets.storage.googleapis.com/user%20profile-title.png');
    }],
    groupNames: [() => {
      return GlobalState.get().auth?.profile?.name || Auth.getUsername(GlobalState.get().auth) || t('groupName');
    }],
    sort: 'zzzz'
  },
  handles: context => {
    return Auth.getProfile(GlobalState.get().auth) != null && !context.mobile;
  },
  appearance: ({
    context,
    action
  }) => {
    return {
      name: t('name'),
      useButton: true,
      // imageOpts : { width : '20px' },
      buttonVariant: 'secondary',
      icon: Config.get('Main', 'logoutIcon', null)
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        dispatch
      }
    } = context;
    dispatch(Auth.logout());
  }
};